










import {Vue, Component, Prop, Watch} from "vue-property-decorator";

@Component
export default class FormGroup extends Vue {
    @Prop()
    public value!: number;

    @Prop({type: Number, default: 1})
    public min!: number;

    @Prop({type: Number, default: 5})
    public max!: number;

    @Prop({type: Boolean, default: false})
    public readOnly!: boolean;

    @Prop({type: String, default: '2x'})
    public size!: string;

    private range: number[] = [];

    private hoveredValue: number | null = null;

    private clicked(i: number) {
        if (!this.readOnly) {
            this.$emit('input', i);
        }
    }

    private created() {
        for (let i = this.min; i <= this.max; i++) {
            this.range.push(i);
        }
    }

    private selectValue(rating: number) {
        this.$emit('input', rating);
    }
}
